export enum API_URL_USER {
  profile = 'users/get-profile',
  change_photo = 'users/change-photo',
  change_password = 'users/change-password',
  olympiad_sub_type = 'admins/roles/get-olymptype-roles',
  refresh_user_erp = 'users/update-profile-by-erp',
}

export enum FILE_API_URL {
  upload_file = 'files/upload-file',   // ?baseFolder=:baseFolder
  upload_files = 'files/upload-files',  // ?baseFolder=:baseFolder

  // achievement = 'files/upload-file?baseFolder=achievement',
  // profile = 'files/upload-file?baseFolder=profile',
  // variant_question_files = 'files/upload-file?baseFolder=variant-question-files',
  // announcement_photos = 'files/upload-file?baseFolder=announcement-photos',
  // question_file = 'files/upload-file?baseFolder=question_files',

  // variant_answer_sheets = 'files/upload-files?baseFolder=variant-answer-sheets',

  download_file = 'files/id:/download',
  download_files = 'files/download-files',
  public_download_file = 'publicfiles/id:/download',
}
